const ListItem = ({ condition = true, ...props }) => {
  return condition ? props : null;
};

export default ListItem;
